export default "__VITE_ASSET__BT0EDPEA__"